import React from 'react'
import update from 'immutability-helper';

import NumericSelect from '../../../../helpers/General/NumericSelect'
import StatesSelect from '../../../States/StatesSelect'
import SingleStateListener from '../../../States/SingleStateListener'

import { user } from '../../../../core/controllers/user';
import { stateRules } from '../../../../core/controllers/StateRules'
import { buildingLevelsState } from '../../../../core/controllers/BuildingLevelsState'
import { modal } from '../../../../core/utilities/modal'

export default class LevelStateListeners extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            stateListeners: null,
            state_rules_id: 0,
            state_priority_level: 0,
            reload: false
        }
    }

    componentDidMount() {
        buildingLevelsState.getBuildingLevelStateRules(this);
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextState.reload == true) {
            nextState.reload = false;
            buildingLevelsState.getBuildingLevelStateRules(this);
        }
    }

    sortStateRulesSelect(e) {
        this.setState({
            state_rules_id: e.target.value
        });
    }
    
    sortPriorityLevel(e) {
        this.setState({
            state_priority_level: e.target.value
        });
    }

    renderSingleStates(data) {
        if (data !== null) {
            if(data.length > 0) {
                return data.map((singleStateData, index) => (
                    <SingleStateListener key={index} data={singleStateData} onDelete={this.removeStateListener.bind(this)}/>
                ));
            } else {
                return (<p>No active state events. Try adding some.</p>);
            }
        }
        else return (<p>No active state events. Try adding some.</p>);
    }

    removeStateListener(levelsStateID) {
        buildingLevelsState.removeLevelsState(levelsStateID, this);
    }

    updateStateListeners(e) {
        if(this.state.state_rules_id == 0) {
            modal.showInfo("Oops! Looks like you forgot to select a state to add!", "warning", "top", "center");
        } else { 
            buildingLevelsState.addBuildingLevelListener(this);
        }
    }
    

    render(){
        const singleStateListener = this.renderSingleStates(this.state.stateListeners);

        return (
            <div class="col-md-8 col-sm-7 col-xs-12" style={{float:'right'}}>
                <div class="card">
                    <div class="header">
                        <h4 class="title"><i class="pe-7s-edit"></i> <small><i class="pe-7s-angle-right"></i></small> Level State Listeners</h4>
                        <p class="category">Your levels will change colors based on the events occurring internally.</p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12">
                                <p class="category"><b>Current State(s) Watched</b></p>
                            </div>
                            {singleStateListener}
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="category"><b>Add State(s)</b></p>
                            </div>
                            <StatesSelect mdColumnSize="4" smColumnSize="6" xsColumnSize="12" onChange={this.sortStateRulesSelect.bind(this)}/>
                            <NumericSelect mdColumnSize="4" smColumnSize="6" xsColumnSize="12" title="State Priority (10 - highest priority)" padding={window.innerWidth > 767 ? "0px" : undefined} increment={11} onChange={this.sortPriorityLevel.bind(this)}/>
                        </div>
                        <br />
                        <div class="row">
                            <div class="col-md-4 col-md-offset-5 col-sm-4 col-sm-offset-4 col-xs-4 col-xs-offset-3">
                                <button type="button" id="save-color-coding" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.updateStateListeners.bind(this)}>
                                    Add State
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Settings/Buildings/Levels/StateListeners.jsx